module.exports = __webpack_public_path__ + "static/media/AutomatedPlacementPortal.ff6fc7f1.png";